import I18n from 'components/I18n'
import _TabMenu from 'components/Legacy/Tabs/TabMenu'
import _TabMenuItem from 'components/Legacy/Tabs/TabMenuItem'
import { actions, selectors } from 'data'
import messages from 'lang'
import endsWith from 'lodash/endsWith'
import React from 'react'
import { connect, ConnectedProps, useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import styled from 'styled-components'
import { color, fontSize, transition } from 'utils'

type PropsType = ConnectedProps<typeof connector>

const TabMenu = styled(_TabMenu)`
  flex: 0;
  border-bottom: 0;

  & > div {
    justify-content: flex-start;
  }
`

const TabMenuItem = styled(_TabMenuItem)`
  font-size: ${fontSize('sm')};
  font-weight: 600;
  transition: color ${transition('medium')};
  color: ${({ selected }) => (selected ? color('white') : color('grey400'))};

  &:hover {
    color: ${color('white')};
  }

  > div {
    height: 2px;
    background: ${color('blue400')};
  }
`

const PageNavigation = ({ isAuthenticated }: PropsType) => {
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isTradePage =
    endsWith('/trade', pathname) ||
    (pathname.includes('/trade/') && !pathname.includes('/trade/simple'))
  const isMarketPage = endsWith('/market', pathname)

  const redirectToMarkets = () => navigate('/market')

  return (
    <TabMenu>
      <TabMenuItem onClick={redirectToMarkets} selected={isMarketPage}>
        <I18n data={messages.markets} />
      </TabMenuItem>
      {/* 
      <TabMenuItem
        onClick={() => {
          dispatch(
            actions.analytics.trackEvent({
              key: 'Trading Clicked',
              properties: {
                origin: 'NAVIGATION'
              }
            })
          )
          navigate('/trade')
        }}
        selected={isTradePage}
      >
        <I18n data={messages.trade} />
      </TabMenuItem>
      */}

      {isAuthenticated && (
        <>
          <TabMenuItem
            onClick={() => {
              dispatch(
                actions.analytics.trackEvent({
                  key: 'Portfolio Clicked',
                  properties: {
                    origin: 'NAVIGATION'
                  }
                })
              )
              navigate('/portfolio')
            }}
            selected={endsWith('/portfolio', pathname)}
          >
            <I18n data={messages.portfolio} />
          </TabMenuItem>
        </>
      )}
    </TabMenu>
  )
}

const mapStateToProps = (state) => ({
  isAuthenticated: selectors.auth.isAuthenticated(state)
})

const connector = connect(mapStateToProps)

export default connector(PageNavigation)
